import * as React from 'react';
import { useTheme } from '@material-ui/core';
import { AppDesignScheme } from '../Api';

// Helper hook for avoid AppDesignScheme and isDark props.When this props was removed in all app,this hook should be removed or renamed.
// Warning! Don't remove it before AppDesignScheme and isDark not removed from props in all app.
// AppDesignScheme to theme map
// isDark: theme.palette.type === 'dark'
// Primary: theme.palette.background.default,
// Secondary: theme.palette.primary.main,
// Tertiary: theme.palette.background.default,
// Font: theme.typography.fontFamily
// Primary: background,
//   Secondary: primary,
//   Tertiary: secondary,
//   Font: fontFamily
type Result = {
  AppDesignScheme: AppDesignScheme;
  isDark: boolean;
};
export const useAppDesignScheme = (): Result => {
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';
  return {
    AppDesignScheme: {
      Font: theme.typography.fontFamily,
      //into customCssToTheme method lost property for dark theme. Remove code bellow when radium removed.
      Primary: isDark ? theme.palette.primary.contrastText : theme.palette.background.default,
      Secondary: theme.palette.primary.main,
      Tertiary: theme.palette.background.default
    },
    isDark: isDark
  };
};
